<template>
    <div v-loading="loading" class="alarmClass">
      <div style="height: 500px; overflow-y: scroll;overflow-x: hidden;">
       
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
          <el-row :gutter="24">
          
  
            <el-col :span="12">
              <el-form-item label="老人身份证附件" prop="name">
                
                <vUpload :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多1张'" :types="['jpg','png']"  :max="5242880" :limit="3" :fileList.sync="form.imgAttach"></vUpload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="医保卡附件" prop="consumableId">
                <vUpload :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多1张'" :types="['jpg','png']"  :max="5242880" :limit="3" :fileList.sync="form.imgAttach"></vUpload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="能力报告" prop="consumableId">
                <vUpload :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多1张'" :types="['jpg','png']"  :max="5242880" :limit="3" :fileList.sync="form.imgAttach"></vUpload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同附件" prop="consumableId">
                <vUpload :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多1张'" :types="['jpg','png']"  :max="5242880" :limit="3" :fileList.sync="form.imgAttach"></vUpload>
              </el-form-item>
            </el-col>
           
          </el-row>
        </el-form>
      </div>
      
    </div>
  </template>
  <script>
import vUpload from "../components/mutil-upload.vue"
  export default {
    components: {vUpload},
  
    props: {
       
      row: {
        default: {},
      },
      nursinghomeId: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        projectList: [],
        form:{
            name:''
        },
        
        formRules: {
          name: [{ required: true, message: '物料名称不能为空', trigger: 'blur' }],
          nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
       
        },
        matetialList: [],
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
  
      

      async initData() {
        
        if (this.model == 'add') {
         
        } else {
        }
      },
      saveRecord() {
       let result= false
          this.$refs['formRef'].validate((valid) => {
            console.log('子',valid)
            result =    valid

        });
          return result
       
      },
      cancleRecord() {
        this.$emit('cancle');
      },
    },
  };
  </script>
  <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
  